import React from 'react';
import clsx from 'clsx';
import { useTranslation } from 'next-i18next';

import Icon from '@components/atoms/icon/icon';

import styles from './seller-fees.module.scss';

export type SellerFeesProps = {
  feeDetails?: {
    sellerFee?: string;
    paymentProcessing?: string;
  };
  modalDialogTitleId: string;
};

const SellerFees: React.FC<SellerFeesProps> = ({ feeDetails, modalDialogTitleId }): React.JSX.Element => {
  const { t } = useTranslation();
  return (
    <div className={clsx('vc-text-l', styles.sellerFees)}>
      <h1
        className={clsx(styles.sellerFees__title, 'vc-text-xl')}
        id={modalDialogTitleId}
      >
        {t('SELLER_FEES.TITLE')}
      </h1>
      <p className={styles.sellerFees__description}>{t('SELLER_FEES.INCLUDE')}</p>

      <ul className={styles.sellerFees__advantgesList}>
        <li className={styles.sellerFees__advantge}>
          <Icon
            className={styles.sellerFees__advantge__icon}
            name="shipping-label"
            ariaHidden
          />
          <p>{t('SELLER_FEES.EASY_SHIPPING')}</p>
        </li>
        <li className={styles.sellerFees__advantge}>
          <Icon
            className={styles.sellerFees__advantge__icon}
            name="chat"
            ariaHidden
          />
          <p>{t('SELLER_FEES.INSURANCE_ITEM')}</p>
        </li>
        <li className={styles.sellerFees__advantge}>
          <Icon
            className={styles.sellerFees__advantge__icon}
            name="members"
            ariaHidden
          />

          <p>{t('SELLER_FEES.ACCESS_COMMUNITY')}</p>
        </li>
        <li className={styles.sellerFees__advantge}>
          <Icon
            className={styles.sellerFees__advantge__icon}
            name="phone"
            ariaHidden
          />

          <p>{t('SELLER_FEES.SELLING_SUPPORT')}</p>
        </li>
      </ul>

      <ul className={clsx(styles.sellerFees__feesList, 'vc-text-s')}>
        {feeDetails?.sellerFee && (
          <li className={styles.sellerFees__fee}>
            {t('SELLER_FEES.SELLING_FEE')} {feeDetails?.sellerFee}
          </li>
        )}

        {feeDetails?.paymentProcessing && (
          <li className={styles.sellerFees__fee}>
            {' '}
            {t('SELLER_FEES.PAYMENT_PROCESS')}*: {feeDetails?.paymentProcessing}
          </li>
        )}
      </ul>

      <p className={clsx(styles.sellerFees__note, 'vc-text-s')}>*{t('SELLER_FEES.COVER_COSTS')}</p>
    </div>
  );
};

export default SellerFees;
